import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
});

Vue.use(Vuex);

const moduleUi = {
  state: {
    layoutHome: true,
    layoutPosition: false,
    sidebarAppInfo: false,
    sidebarMunicipalitiesIndex: false,
    sidebarPositionNew: false,
    sidebarPositionSaved: false,
    sidebarPositionIndex: false,
    sidebarPositionEdit: false,
    sidebarCategoriesIndex: false,
    modalAddLocation: false,
    modalNonParticipant: false,
    modalNonParticipantTwo: false,
    modalReport: false,
    latitude: 49.0,
    longitude: 3,
    gpsLatitude: null,
    gpsLongitude: null,
    activeMunicipality: null,
    activePosition: null,
    activeFeature: null,
    homePosition: null,
    updateFeatures: null,
    selectedNonParticipant: null,
    selectedNonParticipantTwo: null,
    sidebarPositionDetailIndex: false,
    sidebarPositionDetailIndexDeleted: false,
    sidebarPositionDetailIndexStarred: false,
    sidebarPositionDetailIndexPolygon: false,
    sidebarPositionDetailMapView: false,
    pointFeatures: [],
    polygonFeatures: [],
    oaAuthToken: null,
    readFeatures: [],
    starredFeatures: [],
    deletedFeatures: [],
    updatedDevice: false,
    updatedPositionCount: false
  },
  mutations: {
    openSidebarAppInfo(state) {
      state.sidebarAppInfo = true;
    },
    closeSidebarAppInfo(state) {
      state.sidebarAppInfo = false;
    },
    openSidebarMunicipalitiesIndex(state) {
      state.sidebarMunicipalitiesIndex = true;
    },
    closeSidebarMunicipalitiesIndex(state) {
      state.sidebarMunicipalitiesIndex = false;
    },
    openSidebarPositionNew(state) {
      state.sidebarPositionNew = true;
    },
    closeSidebarPositionNew(state) {
      state.sidebarPositionNew = false;
    },
    openSidebarCategoriesIndex(state) {
      state.sidebarCategoriesIndex = true;
    },
    closeSidebarCategoriesIndex(state) {
      state.sidebarCategoriesIndex = false;
    },
    openSidebarPositionSaved(state) {
      state.sidebarPositionSaved = true;
    },
    closeSidebarPositionSaved(state) {
      state.sidebarPositionSaved = false;
    },
    openSidebarPositionIndex(state) {
      state.sidebarPositionIndex = true;
    },
    closeSidebarPositionIndex(state) {
      state.sidebarPositionIndex = false;
    },
    openSidebarPositionEdit(state) {
      state.sidebarPositionEdit = true;
    },
    closeSidebarPositionEdit(state) {
      state.sidebarPositionEdit = false;
    },
    openSidebarPositionDetailIndex(state) {
      state.sidebarPositionDetailIndex = true;
    },
    closeSidebarPositionDetailIndex(state) {
      state.sidebarPositionDetailIndex = false;
    },
    openSidebarPositionDetailMapView(state) {
      state.sidebarPositionDetailMapView = true;
    },
    closeSidebarPositionDetailMapView(state) {
      state.sidebarPositionDetailMapView = false;
    },
    openSidebarPositionDetailIndexDeleted(state) {
      state.sidebarPositionDetailIndexDeleted = true;
    },
    closeSidebarPositionDetailIndexDeleted(state) {
      state.sidebarPositionDetailIndexDeleted = false;
    },
    openSidebarPositionDetailIndexStarred(state) {
      state.sidebarPositionDetailIndexStarred = true;
    },
    closeSidebarPositionDetailIndexStarred(state) {
      state.sidebarPositionDetailIndexStarred = false;
    },
    openSidebarPositionDetailIndexPolygon(state) {
      state.sidebarPositionDetailIndexPolygon = true;
    },
    closeSidebarPositionDetailIndexPolygon(state) {
      state.sidebarPositionDetailIndexPolygon = false;
    },
    openLayoutHome(state) {
      state.layoutHome = true;
    },
    closeLayoutHome(state) {
      state.layoutHome = false;
    },
    openLayoutPosition(state) {
      state.layoutPosition = true;
    },
    closeLayoutPosition(state) {
      state.layoutPosition = false;
    },
    openModalAddLocation(state) {
      state.modalAddLocation = true;
    },
    closeModalAddLocation(state) {
      state.modalAddLocation = false;
    },
    openModalNonParticipant(state, municipality) {
      // to actions instead of mutations?
      state.selectedNonParticipant = municipality;
      state.modalNonParticipant = true;
    },
    closeModalNonParticipant(state) {
      // to actions instead of mutations?
      state.modalNonParticipant = null;
      state.selectedNonParticipant = null;
    },
    openModalNonParticipantTwo(state, municipality) {
      // to actions instead of mutations?
      state.selectedNonParticipantTwo = municipality;
      state.modalNonParticipantTwo = true;
    },
    closeModalNonParticipantTwo(state) {
      // to actions instead of mutations?
      state.selectedNonParticipantTwo = null;
      state.modalNonParticipantTwo = false;
    },
    openModalReport(state) {
      state.modalReport = true;
    },
    closeModalReport(state) {
      state.modalReport = false;
    },
    setActiveMunicipality(state, municipality) {
      state.activeMunicipality = municipality;
      if (municipality.app_asset) {
        state.latitude = municipality.app_asset.latitude;
        state.longitude = municipality.app_asset.longitude;
      }
    },
    setActivePosition(state, position) {
      state.activePosition = position;
    },
    setHomePosition(state, homePosition) {
      state.homePosition = homePosition;
    },
    setActiveFeature(state, feature) {
      state.activeFeature = feature;
    },
    setReadFeatures(state, feature) {
      let readFeatures = state.readFeatures;
      let featureId = feature.properties.id;
      if (!readFeatures.includes(featureId) && feature) {
        let newReadFeatures = readFeatures;
        newReadFeatures.push(featureId);
        state.readFeatures = newReadFeatures;
      }
    },
    setUpdateFeatures(state) {
      state.updateFeatures = Math.random();
    },
    setStarredFeatures(state, features) {
      state.starredFeatures = features;
    },
    setDeletedFeatures(state, features) {
      state.deletedFeatures = features;
    },
    setPointFeatures(state, features) {
      state.pointFeatures = features;
    },
    setPolygonFeatures(state, features) {
      state.polygonFeatures = features;
    },
    setGpsLatitude(state, latitude) {
      state.gpsLatitude = latitude;
    },
    setGpsLongitude(state, longitude) {
      state.gpsLongitude = longitude;
    },
    setOaAuthToken(state, oaAuthToken) {
      state.oaAuthToken = oaAuthToken;
    },
    updatePosition(state, params) {
      state.latitude = params.latitude;
      state.longitude = params.longitude;
    },
    setUpdatedDevice(state) {
      state.updatedDevice = true;
    },
    setUpdatedPositionCount(state, value) {
      state.updatedPositionCount = value;
    }
  }
};

const moduleData = {
  state: {
    loadedPositions: null,
    loadedApp: null,
    loadedCategories: null,
    loadedReportTopics: null,
    loadedGemeentes: null
  },
  mutations: {
    setLoadedPositions(state, positions) {
      state.loadedPositions = positions;
    },
    setLoadedApp(state, app) {
      state.loadedApp = app;
    },
    setLoadedCategories(state, categories) {
      state.loadedCategories = categories;
    },
    setLoadedReportTopics(state, reportTopics) {
      state.loadedReportTopics = reportTopics;
    },
    setLoadedGemeentes(state, gemeentes) {
      state.loadedGemeentes = gemeentes;
    }
  },
  actions: {}
};

export default new Vuex.Store({
  modules: {
    ui: moduleUi,
    data: moduleData
  },
  plugins: [vuexLocal.plugin]
});
